module.exports = __webpack_public_path__ + "img/yellow.3080d27e.jpg";